import { render, staticRenderFns } from "./reportTable.vue?vue&type=template&id=6964537e&"
import script from "./reportTable.vue?vue&type=script&lang=js&"
export * from "./reportTable.vue?vue&type=script&lang=js&"
import style0 from "./reportTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports